import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltipDeliveryDateOverrideLatest: {
		id: 'polaris-components-jpd-implant-kit.ui.interval.tooltip-date-override-latest',
		defaultMessage: 'Latest date from linked delivery work items',
		description: 'Tooltip for delivery date field when overriden with latest date',
	},
	tooltipDeliveryDateOverrideEarliest: {
		id: 'polaris-components-jpd-implant-kit.ui.interval.tooltip-date-override-earliest',
		defaultMessage: 'Earliest date from linked delivery work items',
		description: 'Tooltip for delivery date field when overriden with earliest date',
	},
});
